export default {"src":"/_next/static/media/three-up-arrow.a2eee9e7.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};